<template>
  <div>
    <BaseMitDataTable
          title=""
          :editable="false"
          :showExpanded="true" 
          :showControlHeader="false" 
          :headers="headersHistory"
          :hideDefaultFooter="true"
          itemKey="id"
          :items="activity"
        >
        <template v-slot:tableHeader="{ }">
          <div></div>
        </template>
        <template v-slot:expanded-item="{ item }">
            <!-- expand across all the columns, so use the header length -->
            <td class="pa-1" :colspan="headersHistory.length+1">
              <BaseMitReservationReadOnly :reservation="item.data"/>
            </td>
        </template>
      </BaseMitDataTable>  
  </div>
</template>

<script>
  import BaseMitDataTable from '../BaseMitDataTable.vue';
  import BaseMitReservationReadOnly from './BaseMitReservationReadOnly.vue';

export default {
  name: 'BaseMitReservationActivityList',
  components: {
    BaseMitDataTable,
    BaseMitReservationReadOnly
  },
  props: {
    reservationActivity:{
        default () {
          return [];
        },
        type: Array
      },
    showDetails:{
      default () {
        return false;
      },
      type: Boolean
    }
  },
  data: function() {
    return {
      activity:[],
      headersHistory:[
              {text: 'Type',sortable: true,value: 'type',},
              {text: 'Date',sortable: true,value: 'createDtDate'},
              {text: 'Time',sortable: false,value: 'createDtTime',},
              {text: 'Changed By',sortable: true,value: 'userId',}
            ]
    }
  },
  watch: {
    reservationActivity(newVal, oldVal) {
          this.activity = newVal;
      }
  },
  created() {
    this.activity = this.reservationActivity;
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
</style>
